
<div>
  <div class="radio-inline">
    <input :id="`${$attrs.id}-yes`" type="radio" :value="true"
           v-model.sync="localValue" v-bind="$attrs"
           :disabled="disabled">
    <label :for="`${$attrs.id}-yes`">Yes</label>
  </div>
  <div class="radio-inline">
    <input :id="`${$attrs.id}-no`" type="radio" :value="false"
           v-model.sync="localValue" v-bind="$attrs"
           :disabled="disabled">
    <label :for="`${$attrs.id}-no`">No</label>
  </div>
</div>
